/* Default the bundle picker to the 2-pack (AOV lift). Runs after cheeky-dad.js
   has rendered, and clicks the 2 PAIR card once so all state stays inside
   cheeky-dad.js — no duplicated logic. */
(function(){
var done=false;
function pick(){
if(done)return;
var w=document.getElementById('cd-bundles');
if(!w)return;
var cards=w.querySelectorAll('button');
if(cards.length<2)return;
done=true;
cards[1].click();
}
var tries=0;
var t=setInterval(function(){tries++;pick();if(done||tries>40)clearInterval(t);},80);
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',pick);}else{pick();}
})();
